// @ts-nocheck
import React, { createContext, useContext } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../styles/Toast.css";
import { useAppToast } from "../hooks/useAppToast";
import AchievementUnlockNotifications from "./AchievementUnlockNotifications";

const ToastContext = createContext();

export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error("useToast must be used within ToastProvider");
  }
  return context;
};

export function ToastProvider({ children }) {
  const appToast = useAppToast();

  return (
    <ToastContext.Provider value={appToast}>
      {children}
      <AchievementUnlockNotifications toastApi={appToast} />
      <ToastContainer
        position="top-right"
        autoClose={4000}
        pauseOnHover
        closeOnClick
        newestOnTop
        draggable
        limit={5}
        toastClassName="app-toast"
        bodyClassName="app-toast-body"
        progressClassName="app-toast-progress"
      />
    </ToastContext.Provider>
  );
}
